// extracted by mini-css-extract-plugin
export var clauseRow = "_am-6";
export var emptyState = "_am-b";
export var filterContent = "_am-a";
export var filterGroup = "_am-1";
export var filterGroupContainer = "_am-0";
export var nestedGroup = "_am-2";
export var nestedGroupDepth1 = "_am-3";
export var nestedGroupDepth2 = "_am-4";
export var nestedGroupDepth3 = "_am-5";
export var operatorAnd = "_am-8";
export var operatorOr = "_am-9";
export var operatorToggle = "_am-7";
export var removeGroupButton = "_am-c";